import React from "react";
import { DesktopDashboard, MobileDashboard } from "./components/Dashboard";

const UserDashboardPage: React.FC = () => {
  const isMobile = window.innerWidth <= 640;

  return isMobile ? <MobileDashboard /> : <DesktopDashboard />;
};

export default React.memo(UserDashboardPage);
